import { z } from "zod";
import { AccountUserFieldsSchema } from "./AccountUser";
import { MessageThreadSchema } from "./MessageThread";
import { UserFieldsSchema } from "./User";

export const MessageThreadUserFieldsSchema = z.object({
  id: z.number(),
  userType: z.number(),
  isActive: z.boolean(),
  dateAdded: z.string(),
  messageThread: z.union([MessageThreadSchema, z.any()]),
  accountUser: z.union([AccountUserFieldsSchema, z.any()]),
  userUser: z.union([UserFieldsSchema, z.any()]),
  lastReadMessage: z.any(),
});

export const PartialMessageThreadUserFieldsSchema =
  MessageThreadUserFieldsSchema.deepPartial();

export const MessageThreadUserExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
  hasBeenRead: z.boolean(),
});

export const PartialMessageThreadUserExtraFieldsSchema =
  MessageThreadUserExtraFieldsSchema.deepPartial();

export const MessageThreadUserSchema = z.intersection(
  MessageThreadUserFieldsSchema,
  MessageThreadUserExtraFieldsSchema
);

export type MessageThreadUserFields = z.infer<
  typeof MessageThreadUserFieldsSchema
>;
export type PartialMessageThreadUserFields = z.infer<
  typeof PartialMessageThreadUserFieldsSchema
>;
export type MessageThreadUserExtraFields = z.infer<
  typeof MessageThreadUserExtraFieldsSchema
>;
export type PartialMessageThreadUserExtraFields = z.infer<
  typeof PartialMessageThreadUserExtraFieldsSchema
>;

export type MessageThreadUser = z.infer<typeof MessageThreadUserSchema>;
export type MessageThreadUserPartial = z.infer<
  typeof PartialMessageThreadUserFieldsSchema
>;
